import { useRef } from "react";
import { connect } from "react-redux";
import Avatar from "@material-ui/core/Avatar";
import { makeStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import Card from "../../../components/card";
import ChangeName from "./changeName";
import ChangePhone from "./changePhone";
import ChangeSex from "./changeSex";
import imgAvatar from "../../../assets/images/profile.png";
import {
  Div,
  Row,
  Col,
  Container,
  ProfileInfo,
  Name,
  Phone,
  ProfileLevel,
  ProfileItem,
  ProfileItemValue,
  ProfileContainer,
  EditIcon,
} from "./style";

const useStyles = makeStyles((theme) => ({
  large: {
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
}));

const Profile = (props) => {
  const classes = useStyles();

  const { user, theme } = props;

  const changeNameRef = useRef();
  const changePhoneRef = useRef();
  const changeSexRef = useRef();

  return (
    <>
      <ChangeName refrence={changeNameRef} />
      <ChangePhone refrence={changePhoneRef} />
      <ChangeSex refrence={changeSexRef} />
      <Container className="mx-1 mt-3">
        <Row className="row no-gutters">
          <Col className="col-12">
            <Card className="p-3 text-right">
              <Div className="position-relative pb-2">
                <Avatar
                  alt=""
                  src={imgAvatar}
                  className={`${classes.large} d-inline-block`}
                />
                <ProfileInfo className="d-inline-block vertical-align-top mr-4 mt-2">
                  <Name theme={theme}>{`${
                    user?.data?.name ? user?.data?.name : "مشخص نشده /"
                  } ${
                    user?.data?.family ? user?.data?.family : "مشخص نشده"
                  }`}</Name>
                  <Phone> {user?.data?.phone}</Phone>
                </ProfileInfo>
                <ProfileLevel>مشتری</ProfileLevel>
              </Div>
            </Card>
          </Col>
        </Row>
        <Card className="text-right mt-2">
          <Row className="row no-gutters">
            <ProfileContainer theme={theme} className="col-12">
              <Div className="d-inline-block">
                <ProfileItem>نام و نام خانوادگی:</ProfileItem>
                <ProfileItemValue>{`${
                  user?.data?.name ? user?.data?.name : "مشخص نشده /"
                } ${
                  user?.data?.family ? user?.data?.family : "مشخص نشده"
                }`}</ProfileItemValue>
              </Div>
              <Div className="d-inline-block float-left mt-2-5">
                <IconButton
                  className="p-0"
                  edge="start"
                  color="inherit"
                  aria-label="open drawer"
                  onClick={() => changeNameRef.current.changeStatus()}
                >
                  <EditIcon className="fal fa-edit profile-icon"></EditIcon>
                </IconButton>
              </Div>
            </ProfileContainer>
            <ProfileContainer theme={theme} className="col-12">
              <Div className="d-inline-block">
                <ProfileItem>شماره تلفن همراه:</ProfileItem>
                <ProfileItemValue>
                  {user?.data?.phone ? user?.data?.phone : "مشخص نشده"}
                </ProfileItemValue>
              </Div>
              <Div className="d-inline-block float-left mt-2-5">
                <IconButton
                  className="p-0"
                  edge="start"
                  color="inherit"
                  aria-label="open drawer"
                  onClick={() => changePhoneRef.current.changeStatus()}
                >
                  <EditIcon className="fal fa-edit profile-icon"></EditIcon>
                </IconButton>
              </Div>
            </ProfileContainer>
            <ProfileContainer theme={theme} className="col-12">
              <Div className="d-inline-block">
                <ProfileItem>جنسیت:</ProfileItem>
                <ProfileItemValue>
                  {user?.data?.sex_text ? user?.data?.sex_text : "مشخص نشده"}
                </ProfileItemValue>
              </Div>
              <Div className="d-inline-block float-left mt-2-5">
                <IconButton
                  className="p-0"
                  edge="start"
                  color="inherit"
                  aria-label="open drawer"
                  onClick={() => changeSexRef.current.changeStatus()}
                >
                  <EditIcon className="fal fa-edit profile-icon"></EditIcon>
                </IconButton>
              </Div>
            </ProfileContainer>
          </Row>
        </Card>
      </Container>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.auth.user,
    theme: state.theme,
  };
};

export default connect(mapStateToProps, false)(Profile);
